import Lead from '../components/leads/Index.vue';
import ViewLead from '../components/leads/View.vue';
export default [
	{
		path: '/leads',
		name: 'Leads',
		component: Lead,
		meta: {
			requiresAuth: true,
			permissions: {
				Leads: ['View Leads', 'Create Leads']
			}
		}
	},
	{
		path: '/leads/:lead_id',
		name: 'ViewLead',
		component: ViewLead,
		meta: {
			requiresAuth: true,
			permissions: {
				Leads: ['View Leads']
			}
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/LeadRoutes.js